import React from 'react';
import { Navbar , Footer } from '../../_components';
import { MainPanel } from './MainPanel';
import { HWGCashPanel } from './HWGCashPanel';
import Carousel from 'nuka-carousel';

export class HomePage extends React.Component
{
    render(){
        return (
            <div>
                <Navbar/>

                <Carousel swiping dragging autoplay wrapAround autoplayInterval={10000}  
                    renderCenterLeftControls={({ previousSlide }) => (
                        <span onClick={previousSlide}><i className="fa fa-angle-left"></i></span>
                    )}
                    renderCenterRightControls={({ nextSlide }) => (
                        <span onClick={nextSlide}><i className="fa fa-angle-right"></i></span>
                    )}>
                    <HWGCashPanel />
                    <MainPanel />
                </Carousel>

                <section className="section border-bottom m-t-xl">
                    <div className="container">
                        <div className="columns">
                            <div className="column is-4 boxmain-single">
                                <ul>
                                    <li><div className="home-icon home-icon-1"></div></li>
                                    <li><h5>Custody Services</h5></li>
                                    <li>
                                    We are a company that is licensed to hold your fiat and digital assets in trust on your behalf. 
                                    </li>
                                    <li>
                                        <a href="#" className="btn">
                                            Learn More
                                            <span className="icon link"><i className="fas fa-chevron-right"></i></span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="column is-4 boxmain-single">
                                <ul>
                                    <li><div className="home-icon home-icon-2"></div></li>
                                    <li><h5>Regulated Oversight</h5></li>
                                    <li>
                                    We are a Labuan Company regulated by the Labuan Financial Services Authority with transparent reporting and stringent auditing.
                                    </li>
                                    <li>
                                        <a href="#" className="btn">
                                            Learn More
                                            <span className="icon link"><i className="fas fa-chevron-right"></i></span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="column is-4 boxmain-single">
                                <ul>
                                    <li><div className="home-icon home-icon-3"></div></li>
                                    <li><h5>Premium Services</h5></li>
                                    <li>
                                    Personalized trading support by our dedicated representatives for all your trading needs and wants.
                                    </li>
                                    <li>
                                        <a href="#" className="btn">
                                            Learn More
                                            <span className="icon link"><i className="fas fa-chevron-right"></i></span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
                
                <section className="section border-bottom section-nopadding">
                    <div className="container">
                        <div className="columns">
                            <div className="column is-6 boxmain-single m-t-xl">
                                <ul>
                                    <li><h5>Trading</h5></li>
                                    <li>
                                    HWG Exchange is an easy-to-use platform which provides a transparent and incentive-based trading experience.                                    </li>
                                    
                                    <li>
                                        <a href="#" className="btn">
                                            Learn More
                                            <span className="icon link"><i className="fas fa-chevron-right"></i></span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="column is-6 boxmain-single">
                                <div className="home-banner-1"></div>
                            </div>
                        </div>
                    </div>
                </section>

                
                <section className="section m-t-xl">
                    <div className="container">
                        <div className="columns">
                            <div className="column is-four-sixths is-offset-one-sixth boxmain-single has-text-centered">
                                <ul>
                                    <li><h5>HWGG Capital P.L.C</h5></li>
                                    <li>
                                    We built a next generation digital asset exchange and custodian so you can buy, sell, and store digital assets in a regulated, secure, and compliant manner.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer/>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Views/HomePage/HomePage.jsx